(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal-display"] && !Shopify.designMode) return;
  try {
     
  const targetmodal = document.querySelector('.modal-display-wrapper');
  const sessionStrageKey = 'modal-display';
  const sessionStrageValue = 'on';
  const closeBtn = document.querySelector('.close-btn');

  window.addEventListener('load', () => {
    if (!sessionStorage.getItem(sessionStrageKey)) {
    //sessionStrageに記録されているかで分岐
      sessionStorage.setItem(sessionStrageKey, sessionStrageValue);
      setTimeout(() => {
        targetmodal.classList.add('active');
      }, 100);
    }
  });
  closeBtn.addEventListener('click', () => {
    targetmodal.classList.remove('active');
  });



  } catch(e) { console.error(e); }
})();
})();
